// src/components/layout/Head.tsx
import { Helmet } from 'react-helmet-async';
import { siteConfig, schemaData } from '@/lib/seo-config';

interface HeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  schema?: object;
  noindex?: boolean;
}

const Head = ({ 
  title = "PayPal Gebührenrechner 2025 » Aktuelle Gebühren berechnen",
  description = siteConfig.description,
  canonical = siteConfig.url,
  schema = schemaData.calculator,
  noindex = false
}: HeadProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.name} />
      <meta property="og:locale" content="de_DE" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {/* Keywords and Robots */}
      <meta name="keywords" content={siteConfig.keywords.join(', ')} />
      <meta 
        name="robots" 
        content={noindex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"} 
      />
      
      {/* Language and Viewport */}
      <html lang="de" />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      
      {/* Schema.org */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
      
      {/* Additional Meta Tags */}
      <meta name="author" content={siteConfig.name} />
      <meta name="application-name" content={siteConfig.name} />
      <meta name="mobile-web-app-capable" content="yes" />
      
      {/* Preconnect to necessary domains */}
      <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Helmet>
  );
};

export default Head;